import { APP_CONFIGS } from "../constants";
import { clearCookies } from "../helpers/utils";
import {
    IAuthTokens,
    IFirstLoginRequest,
    ILogin,
    IPasswordChange,
    IPasswordRecover,
    IRequest,
    IRequestError
} from "../interfaces/authentication.interface";
import { basicRequest, request } from "./requests.service";

export const getForm = async (
    formId: string
): Promise<IRequest<any | IRequestError>> => {
    try {
        const response = await request.get<any>(`/typeform/forms/${formId}`);

        return { success: true, data: response.data };
    } catch (error: any) {
        return { success: false, data: []};
    }
};